/**
 * Tri, recherche et filtres pour listes Phase 1 (règle GSD listes/tableaux).
 */

/**
 * @param {Record<string, unknown>[]} rows
 * @param {string} query
 * @param {string[]} fields
 */
export function filterBySearch(rows, query, fields) {
  const q = query.trim().toLowerCase();
  if (!q) return rows;
  return rows.filter((row) =>
    fields.some((f) => String(row[f] ?? "").toLowerCase().includes(q)),
  );
}

/**
 * @param {Record<string, unknown>[]} rows
 * @param {string} field
 * @param {string} value
 */
export function filterByField(rows, field, value) {
  if (!value || value === "all") return rows;
  return rows.filter((row) => String(row[field]) === value);
}

/**
 * @param {Record<string, unknown>[]} rows
 * @param {string|null} sortKey
 * @param {'asc'|'desc'} direction
 */
export function sortRows(rows, sortKey, direction = "asc") {
  if (!sortKey) return rows;
  const mult = direction === "desc" ? -1 : 1;
  return [...rows].sort((a, b) => {
    const av = String(a[sortKey] ?? "").toLowerCase();
    const bv = String(b[sortKey] ?? "").toLowerCase();
    if (av < bv) return -1 * mult;
    if (av > bv) return 1 * mult;
    return 0;
  });
}

/**
 * @param {Record<string, unknown>[]} rows
 * @param {string} field
 */
export function uniqueValues(rows, field) {
  return [...new Set(rows.map((r) => String(r[field] ?? "")).filter(Boolean))].sort();
}
